import { render, staticRenderFns } from "./EditLoyaltyTier.vue?vue&type=template&id=6e61ed8c&"
import script from "./EditLoyaltyTier.vue?vue&type=script&lang=js&"
export * from "./EditLoyaltyTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports